// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__FCfbH"};